import { render, staticRenderFns } from "./SoftwareLanguage.vue?vue&type=template&id=7d442d0a&"
import script from "./SoftwareLanguage.vue?vue&type=script&lang=js&"
export * from "./SoftwareLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLanguage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d442d0a')) {
      api.createRecord('7d442d0a', component.options)
    } else {
      api.reload('7d442d0a', component.options)
    }
    module.hot.accept("./SoftwareLanguage.vue?vue&type=template&id=7d442d0a&", function () {
      api.rerender('7d442d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SoftwareLanguage.vue"
export default component.exports